// extracted by mini-css-extract-plugin
module.exports = {"result":"result-da0","resultActions":"result__actions-91e","actions":"actions-48e","actionsLink":"actions__link-80e","actionsButton":"actions__button-a00"};